module.exports = "#id {}\n\n.red-text {\n  font-color: red;\n}\n"